<script setup>
import {onMounted, ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionRoot} from '@headlessui/vue';
import DynamicForm from '@/views/DynamicForm.vue';
import {useRoute} from 'vue-router';
import clientService from '@/services/ClientService';
import {useI18n} from 'vue-i18n';
import InvestmentQuestionnaireService, {visibleInvestmentQuestionnaireResultKeys} from '@/services/InvestmentQuestionnaireService';
import {setButtonContentDefault, setButtonContentLoading, setButtonsContentSuccess, showSuccessMessage} from '@/helper';
import {authData} from '@/services/AuthService';
import DocumentService from "@/services/DocumentService";

const {t, te} = useI18n();
const props = defineProps({
  results: {type: Object, required: false},
});

const emit = defineEmits(['confirm', 'cancel']);
const isOpen = ref(true);

const result = ref(null);

const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm');
    } else {
      emit('cancel');
    }
  }, 300);
};

function openModal() {
  isOpen.value = true;
}

onMounted(() => {
  if (props.results) {
    result.value = props.results;
  }
});

</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                Výsledky
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')" id="investmentQuestionnaireForm">
              <div class="row mb-3">
                <div class="col-12">
                  <br/>
                  <fieldset>
                    <legend>{{ t('investmentQuestionnaireModal.result') }}</legend>
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">{{ t('investmentQuestionnaireModal.metric') }}</th>
                          <th scope="col">{{ t('investmentQuestionnaireModal.review') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="key in visibleInvestmentQuestionnaireResultKeys">
                          <td scope="row">{{ t('investmentQuestionnaireModal.' + key) }}</td>
                          <td>{{ te('investmentQuestionnaireModal.' + result?.[key]) ? t('investmentQuestionnaireModal.' + result?.[key]) : (result?.[key] || '-') }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-link text-decoration-underline text-dark" type="button" @click="closeModalWith('cancel')">{{ t('investmentQuestionnaireModal.cancel') }}</button>
                </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

